import React from 'react';
var currentYear = new Date().getFullYear();
var copyrightConfig = {
  copyRightText: /*#__PURE__*/React.createElement(React.Fragment, null, "\xA9 Argos Limited ", currentYear, ". All Rights Reserved.")
};
var legalLinks = [{
  dataTest: 'footer-accessibility',
  href: 'https://www.argos.co.uk/help/accessibility-statement',
  rel: 'noopener',
  target: '_blank',
  text: 'Accessibility',
  onClickParam: 'accessibility'
}, {
  dataTest: 'footer-privacy-hub',
  href: 'https://privacy-hub.sainsburys.co.uk',
  rel: 'noopener',
  target: '_blank',
  text: 'Privacy hub',
  onClickParam: 'privacyHub'
}, {
  dataTest: 'footer-privacy-policy',
  href: 'https://privacy-hub.sainsburys.co.uk/privacy-policy/',
  rel: 'noopener',
  target: '_blank',
  text: 'Privacy policy',
  onClickParam: 'privacyPolicy'
}, {
  dataTest: 'footer-cookies-policy',
  href: 'https://privacy-hub.sainsburys.co.uk/cookie-policy/',
  rel: 'noopener',
  target: '_blank',
  text: 'Cookies policy',
  onClickParam: 'cookiePolicy'
}, {
  dataTest: 'footer-cookie-list',
  href: 'https://www.argos.co.uk/help/cookie-list/',
  rel: 'noopener',
  target: '_self',
  text: 'List of cookies',
  onClickParam: 'listOfCookies'
}, {
  dataTest: 'footer-cookie-preferences',
  type: 'button',
  text: 'Cookie preferences',
  onClickParam: 'onCookiePreferencesClick'
}, {
  dataTest: 'footer-terms-and-conditions',
  href: '/help/terms-and-conditions',
  target: '_blank',
  rel: 'noopener',
  text: 'Terms & conditions',
  onClickParam: 'termsAndConditions'
}];
export { copyrightConfig, legalLinks };